/**
 * Pure helpers for Modal focus-trap keyboard handling (keeps Modal CC under CRAP gate).
 */

export function focusableIn(container: HTMLElement): HTMLElement[] {
  return Array.from(
    container.querySelectorAll<HTMLElement>(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    ),
  );
}

/** Returns true when the event was handled (Escape or Tab trap). */
export function handleModalKeyNavigation(
  e: KeyboardEvent,
  options: {
    isOpen: boolean;
    closeOnEscape: boolean;
    onClose: () => void;
    container: HTMLElement | null;
  },
): boolean {
  if (!options.isOpen) return false;

  if (e.key === 'Escape' && options.closeOnEscape) {
    e.preventDefault();
    options.onClose();
    return true;
  }

  if (e.key !== 'Tab' || !options.container) return false;

  const focusable = focusableIn(options.container);
  if (focusable.length === 0) return false;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
    return true;
  }
  if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
    return true;
  }
  return false;
}
